
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mma",
      function () {
        return require("private-next-pages/mma.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mma"])
      });
    }
  